import React, { Component } from 'react';
import BackupcarStore from 'stores/BackupcarStore';
import { Button, Modal, Form, FormGroup, Col, ControlLabel, FormControl, InputGroup, OverlayTrigger, Popover } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import CkTimePicker from 'component/element/CkTimePicker'
import SearchCarButton from 'component/element/SearchCarButton'
import { SliderPicker } from 'react-color';
import Select from 'react-select';
import './carplan.css'
import ConfirmPopup from 'component/element/ConfirmPopup';
import { Checkbox } from 'react-icheck';
import {connect} from 'react-redux'
const NotificationSystem = require('react-notification-system');

class BackupCarReservedModal extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
  }

  initState(newState) {
    let state = {
      loading:false,
      isSave:true,
      doc:this.getEmptyDoc(),
      validDoc:this.getEmptyValidDoc(),
      seq:-1,
      bg_select:'#0288d1',
      is_return:false,
      showDel:false,
      ref_list:[],
      showCar:false
    }
    if (newState !== undefined) {
      state = Object.assign(state, newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  getEmptyDoc() {
    return {return_status:"0",return_date:null,return_time:null,ref_no:"",remark:"",car_registration_no:"",start_date:"",end_date:"",work_no:"",background:"#0288d1"}
  }

  getEmptyValidDoc() {
    return {return_date_time:null,ref_no:null,car_registration_no:null,start_date:null,end_date:null}
  }

  onShow() {
    let {is_return,doc,validDoc,bg_select,seq,brId} = this.props
    this.onLoadCarReadyReserved()
    if (brId) {
      BackupcarStore.loadReservationItem(brId,(result)=>{
        doc.return_status = result.data.return_status
        doc.return_date = result.data.return_date
        doc.return_time = result.data.return_time
        doc.ref_no = result.data.ref_no
        doc.remark = result.data.remark
        doc.car_registration_no = result.data.car_registration_no
        doc.start_date = result.data.start_date
        doc.end_date = result.data.end_date
        doc.work_no = result.data.work_no
        doc.background = result.data.background
        this.setState({is_return:(doc.return_status==='1'?true:false),doc:doc,validDoc:validDoc,bg_select:bg_select,seq:seq})
      })
    } else
      this.setState({is_return:is_return,doc:doc,validDoc:validDoc,bg_select:bg_select,seq:seq})
  }

  onJustEditHide() {
    if (this.props.onJustEditHide!==undefined)
      this.props.onJustEditHide()
  }

  onEditHide() {
    if (this.props.onEditHide!==undefined)
      this.props.onEditHide()
  }

  onLoadCarReadyReserved() {
    BackupcarStore.loadCarReadyReserved((result)=>{
      let ref_list = result.data.map((item,index)=>{
        return {label:item.ref_no,value:item.ref_no}
      })
      this.setState({ref_list:ref_list})
    })
  }

  onDocChange(field,e) {
    let {doc} = this.state
    doc[field] = (field==='ref_no'?(e?e.value:''):e.target.value)
    this.setState({doc:doc})
  }

  onDateChange(field,e) {
    let {doc} = this.state
    doc[field] = e
    this.setState({doc:doc})
  }

  onColorChange(color,e) {
    let {doc} = this.state
    doc['background'] = color.hex
    this.setState({doc:doc,bg_select:color.hex})
  }

  onReturnChange(val) {
    let {doc} = this.state
    doc.return_status = val?'1':'0'
    this.setState({is_return:val,doc:doc})
  }

  onValid(validDoc) {
    this.setState({validDoc:validDoc,isSave:true,loading:false})
  }

  onEditSave() {
    this.setState({isSave:false},()=>{
      if (this.props.onBeforeEditSave!==undefined) {
        let {validDoc,doc,seq,is_return} = this.state
        let obj = {validDoc:validDoc,doc:doc,seq:seq,is_return:is_return}
        this.props.onBeforeEditSave(obj,(status)=>{
          this.onJustEditHide()
          if (status==='OK') {
            this.setState({bg_select:'#0288d1',is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})
          } else {
            this.setState({loading:false,bg_select:'#0288d1',is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})
          }  
        })
      }
    })
  }

  onConfirmDel() {
    if (this.props.onConfirmDel!==undefined) {
      this.props.onConfirmDel((status)=>{
        this.onDelHide()
        if (status==='OK') {
          this.setState({bg_select:'#0288d1',is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})
        } else {
          this.setState({loading:false,bg_select:'#0288d1',is_return:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc(),seq:-1})
        }
      })
    }  
  }

  onDelOpen() {
    this.setState({showDel:true})
  }

  onDelHide() {
    this.setState({showDel:false})
  }

  onCarSearchSelect(e) {
    let {doc} = this.state
    doc.car_registration_no = (typeof e.car_registration_no!=='undefined'?e.car_registration_no:e.Value)
    doc.work_no = e.work_no
    this.setState({doc:doc})
  }

  renderEditModal() {
    let {isSave,is_return,doc,validDoc,bg_select,seq} = this.state
    let {show,disabledSelectWork} = this.props
    const bgSelect = (
      <Popover id="popover-bg-select" title="เลือกแถบสี">
        <SliderPicker 
          color={doc.background}
          onChangeComplete={this.onColorChange.bind(this)}
        >
        </SliderPicker>
      </Popover>
    )
    return(
			<div>
				<Modal show={show} enforceFocus={false} onHide={this.onEditHide.bind(this)} onShow={this.onShow.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>รายการสำรองรถ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup validationState={validDoc.ref_no}>
                <Col componentClass={ControlLabel} sm={4}>
                  เลขอ้างอิง/ทะเบียนรถสำรอง
                </Col>
                <Col sm={7}>
                  <Select                  
                    placeholder='เลขอ้างอิง/ทะเบียนรถสำรอง'
                    value={doc.ref_no}
                    options={this.state.ref_list}
                    onChange={this.onDocChange.bind(this,'ref_no')}
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={validDoc.car_registration_no}>
                <Col componentClass={ControlLabel} sm={4}>
                  ทะเบียนรถ (ซ่อม)
                </Col>
                <Col sm={7}>
                  {!disabledSelectWork
                  ?
                  <InputGroup>
                    <FormControl readOnly={true} value={doc.car_registration_no} onChange={this.onDocChange.bind(this,'car_registration_no')} placeholder='ทะเบียนรถ (ซ่อม)' />
                    <InputGroup.Addon className="btn" onClick={()=>this.setState({showCar:true})}><FontAwesome name='plus' /></InputGroup.Addon>
                  </InputGroup>  
                  :
                  <FormControl readOnly={true} value={doc.car_registration_no} onChange={this.onDocChange.bind(this,'car_registration_no')} placeholder='ทะเบียนรถ (ซ่อม)' />}
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  หมายเหตุ
                </Col>
                <Col sm={7}>
                  <FormControl value={doc.remark} onChange={this.onDocChange.bind(this,'remark')} placeholder='หมายเหตุ' />
                </Col>
              </FormGroup>
              <FormGroup validationState={validDoc.start_date}>
                <Col componentClass={ControlLabel} sm={4}>
                  วันยืมรถ
                </Col>
                <Col sm={7}>
                  <DatePicker
                    showFooter={true}
                    popPlacement='bottom'
                    value={doc.start_date} 
                    onChange={this.onDateChange.bind(this,'start_date')}
                    isFormG={false}
                  />  
                </Col>
              </FormGroup>
              <FormGroup validationState={validDoc.end_date}>
                <Col componentClass={ControlLabel} sm={4}>
                  วันคืนรถ
                </Col>
                <Col sm={7}>
                  <DatePicker
                    showFooter={true}
                    popPlacement='bottom'
                    value={doc.end_date} 
                    onChange={this.onDateChange.bind(this,'end_date')}
                    isFormG={false}
                  />  
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  แถบสี
                </Col>
                <Col sm={7}>
                  <OverlayTrigger rootClose trigger={["click"]} placement="top" overlay={bgSelect}>
                    <div style={{borderRadius:'4px',marginTop:'5px',cursor:'pointer',backgroundColor:bg_select,width:'100%',height:'100%'}}><br /></div>
                  </OverlayTrigger>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  
                </Col>
                <Col sm={7}>
                  <Checkbox
                    onChange={this.onReturnChange.bind(this,!is_return)}
                    checked={is_return}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' คืนรถแล้ว'}
                  >
                  </Checkbox>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(is_return?'':'none')}} validationState={validDoc.return_date_time}>
                <Col componentClass={ControlLabel} sm={4}>
                  วัน-เวลาคืนรถ
                </Col>
                <Col sm={4}>
                  <DatePicker
                    showFooter={true}
                    popPlacement='bottom'
                    value={doc.return_date?doc.return_date:''} 
                    onChange={this.onDateChange.bind(this,'return_date')}
                    isFormG={false}
                  />  
                </Col>
                <Col sm={4}>
                  <CkTimePicker
                    value={doc.return_time?doc.return_time:''}
                    onTimeSaved={this.onDateChange.bind(this,'return_time')}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='danger' style={{display:(seq!==-1?'':'none'),float:'left'}} onClick={this.onDelOpen.bind(this)}><FontAwesome name='trash' />&nbsp;ลบ</Button>
            <div className='pull-right'>
              <Button disabled={isSave?false:true} onClick={this.onEditSave.bind(this)} bsStyle='primary'><FontAwesome name='save' />&nbsp;บันทึก</Button>
              <Button onClick={this.onEditHide.bind(this)}><FontAwesome name='close' />&nbsp;ปิด</Button>
            </div>
          </Modal.Footer>
        </Modal>
			</div>
		)
  }

  render() {
    return(
      <div>
        {this.renderEditModal()}
        <ConfirmPopup 
          show={this.state.showDel}
          title={'ยืนยันลบการย้ายวันสำรองรถ'}
          message={'ยืนยันลบการย้ายวันสำรองรถหรือไม่ ?'}
          onConfirm={this.onConfirmDel.bind(this)}
          onHide={this.onDelHide.bind(this)}
        />
        <SearchCarButton
          show={this.state.showCar}
          onHide={()=>{this.setState({showCar:false})}}
          onSelect={this.onCarSearchSelect.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  } 
}

BackupCarReservedModal.defaultProps = {
  disabledSelectWork:false,
  brId:null
}

export default connect(
  (state) => ({messages: state.message.view.backupcar.BackupCarRegistration}),null,null,{withRef:true}
)(BackupCarReservedModal);


// WEBPACK FOOTER //
// ./src/view/backupcar/BackupCarReservedModal.js